Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Widget1998546280",
  {"ccpa":"Widget1998546280--ccpa","text":"Widget1998546280--text","link":"Widget1998546280--link","root":"Widget1998546280--root"},
  "",
  8,
  "Widget1998546280"
);

